// API読み込み
let tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
let firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// API読み込み後にプレーヤーの設定
let player;

function onYouTubeIframeAPIReady() {
  player = new YT.Player('player');
}

function playVideo() {
  player.playVideo();
}

let windowSize = {
  w: window.innerWidth,
  h: window.innerHeight,
  aspect: window.innerWidth / window.innerHeight
}

window.addEventListener(`resize`, () => {
  windowSize = {
    w: window.innerWidth,
    h: window.innerHeight,
    aspect: window.innerWidth / window.innerHeight
  }
});


let _body, _header, headerH, scrollAmount;

function initCommon() {
  _body = document.body;
  _header = document.querySelector(`.js-follow`);
  headerH = _header.clientHeight;
  scrollAmount = pageYOffset;
}

/**
 * DOMContentLoaded
 */

document.addEventListener(`DOMContentLoaded`, () => {

  initCommon()
  window.addEventListener(`resize`, initCommon);
  window.addEventListener(`scroll`, () => {
    scrollAmount = pageYOffset;
  })


  /**mainVisual setting CSS */
  let _visual = document.querySelector(`.js-visual`);
  if (_visual !== null) {
    let tempW = windowSize.w;
    let _container;

    setSize();
    window.addEventListener(`resize`, () => {
      if (tempW !== windowSize.w) {
        setSize();
      }
    })

    function setSize() {
      _container = document.querySelector(`.js-anime`);
      TweenMax.set(_container, {
        paddingTop: windowSize.h
      });
    }
  }



  /**Player */
  let _poster = document.querySelector(`.js-poster`);
  if (_poster !== null) {
    _poster.addEventListener(`click`, (e) => {
      e.preventDefault();
      e.stopPropagation();

      TweenMax.to(_poster, 0.2, {
        alpha: 0,
        display: 'none',
        onComplete: playVideo
      });

      return false;
    }, false)
  }

});

/**
 * load
 */
window.addEventListener('load', () => {

  initCommon()

  /**mainVisual */
  let _visual = document.querySelector(`.js-visual`);
  if (_visual !== null) {
    fixedImage();
    window.addEventListener(`scroll`, fixedImage);
    function fixedImage() {
      if (scrollAmount > windowSize.h) {
        TweenMax.set(_visual, {
          top: windowSize.h - scrollAmount
        });
      }
    }

    let speed = 0.8;

    scrollAmount = pageYOffset;
    if (scrollAmount < windowSize.h * 0.5) {

      TweenMax.set(`.js-container`, {
        alpha: 0
      })
      window.scrollTo(0, 0);
      _body.classList.add(`stop-scrolling`);
      opening();

    } else if (scrollAmount >= windowSize.h * 0.5 && scrollAmount < windowSize.h) {
      window.scrollTo(0, windowSize.h + headerH)
    }

    function opening() {
      TweenMax.fromTo(_visual, 2, {
        opacity: 0,
      }, {
        opacity: 1,
        ease: Power1.easeIn,
        onComplete: function () {
          /**opening Scroll */
          TweenMax.to(`.js-container`, 0.5, {
            alpha: 1,
            delay: 1,
          })
          TweenMax.to(window, speed, {
            scrollTo: {
              y: windowSize.h + headerH,
              offsetY: 0,
              autoKill: false,
            },
            delay: 1,
            onComplete: function () {
              _body.classList.remove(`stop-scrolling`);
            }
          });
        }
      })
    }

    let fadeAndSlide = (element, dis, duration) => {
      return TweenMax.fromTo(element, duration, {
        x: dis,
        alpha: 0
      }, {
        x: 0,
        alpha: 1
      });
    }


    let xDis = deviceIsSp ? 50 : 100;
    let _fade = document.querySelectorAll(`.js-fadein`);
    for (let i = 0; i < _fade.length; i++) {
      let fadeSide = fadeAndSlide(_fade[i], xDis, speed);
      let fadeTitle = new ScrollMagic.Scene({
          triggerElement: _fade[i],
          triggerHook: 0.8, // 開始の上下
          reverse: true,
          offset: 0, //トリガーの要素の上下
        })
        .setTween(fadeSide)
        .addTo(controller);
    }

  }



  /**PLayer Follow */
  let _follow = document.querySelector(`.js-playerfollow__inner`);
  if (_follow !== null) {
    let _followP, playerHeight, device, pageH;

    const initFollowElement = () => {
      device = windowSize.w < 751 ? true : false;
      _follow = document.querySelector(`.js-playerfollow__inner`);
      _followP = document.querySelector(`.js-playerfollow`);
      playerHeight = _follow.clientHeight;
      _followP.style.height = playerHeight + `px`;
      pageH = document.querySelector(`.js-animewrap`).clientHeight;
      adjustFollowElement();
    }

    const adjustFollowElement = (e) => {
      if (device) {
        //scroll制限
        let stop = maxScroll(e);
        _follow.classList.add(`follow`);

        if (stop !== 0) {
          TweenMax.set(_follow, {
            top: stop - window.pageYOffset
          });
        } else {
          if (_header.classList.contains(`is-show`)) {
            TweenMax.to(_follow, 0.2, {
              top: headerH
            });
          } else {
            TweenMax.to(_follow, 0.2, {
              top: 0
            });
          }
        }

      } else {
        if (_follow.classList.contains(`follow`)) {
          _follow.classList.remove(`follow`);
          TweenMax.to(_follow, 0.2, {
            top: 0
          });
        }
      }
    }

    const maxScroll = (ev) => {
      let max = pageH + headerH - windowSize.h;
      if (scrollAmount - max > 0) {
        return max;
      } else {
        return 0;
      }
    }

    initFollowElement();
    window.addEventListener(`resize`, initFollowElement);
    window.addEventListener(`scroll`, adjustFollowElement);
  }


});